import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {CameraService} from "../services/camera.service";
import {animate, state, style, transition, trigger} from "@angular/animations";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {DomSanitizer} from "@angular/platform-browser";
import {HttpClient, HttpEventType} from "@angular/common/http";
import {FotoPreviewComponent} from "../../dialog/foto-preview/foto-preview.component";
import {WebsocketService} from "../services/websocket.service";
import {TranslateService} from "@ngx-translate/core";
import {InfoOverlayComponent} from "../../dialog/noclosing/info-overlay.component";
import {EmbedService} from "../../services/embed.service";
import {Subscription} from "rxjs";
import {PortalService} from "../../services/portal.service";
import {HeizcheckBackendService} from "../services/backend.service";
import {HeizcheckRequestService} from "../services/heizcheck-request.service";
import {HeizcheckConstants} from "../heizcheck.constants";
import {ElementService} from "../../services/element.service";
import {HeizcheckAnfrage} from "../anfrage/heizcheck.anfrage";
import {HeizkostenabrechnungForm} from "../heizkostenabrechnung/heizkostenabrechnung.form";
import {EnergyMapService} from "../../energy-map/services/energy.map.service";

declare let __advisorRedirectUrl: string;

@Component({
    selector: 'app-erfassen',
    templateUrl: './erfassen.component.html',
    animations: [
        trigger('fade', [
            state('open', style({
                'max-height': '200px',
                opacity: 1
            })),
            state('closed', style({
                'max-height': '0px',
                opacity: 0
            })),
            transition('* => open', [
                animate('300ms ease-in')
            ]),
        ])
    ],
    standalone: false
})
export class ErfassenComponent implements OnInit, OnDestroy, AfterViewInit {

  /**
   * mode that should be used. upload or foto
   */
  mode: string = 'upload';

  /**
   * Holds the number string for the smartphone connection
   */
  fotoNumber: string;

  /**
   * holds the URL for making fotos
   */
  redirectUrl: string;

  /**
   * url for taking a foto
   */
  photoURL: string = null;

  /**
   * Dialog for showing the preview images from the mobile photos.
   */
  previewDialog: MatDialogRef<FotoPreviewComponent> = null;

  /**
   * List of files we want to offer for upload
   */
  files: any = [];

  /**
   * holds the upload percentage of the fileupload.
   */
  uploadPercentage: number = null;

  /**
   * a global interval to show waiting animation texts
   */
  interval: any;

  /**
   * global dialog for waiting animation.
   */
  infoDialog: any;

  /**
   * Is this page abmedded or not
   */
  isEmbedded: boolean = false;

  /**
   * Holds if the terms are accepted or not.
   */
  terms: boolean = false;

  /**
   * Subscription for webservice messages.
   */
  webserviceSubscription: Subscription;

  /**
   * toogle for the page help
   */
  showPageHelp: boolean = false;

  /**
   * Holding the users request object
   */
  anfrage: HeizcheckAnfrage;

  /**
   * holds the old mode to navigate back, when showing the result page
   */
  oldMode: string = null;

  /**
   * Counter for the number of fields that we detected
   */
  detectedValueCount: number = 0;

  /**
   * the minimum of detected values we need for a success
   */
  minDetectedValueCount: number;

  /**
   * Show error message if form is not valid
   */
  error: string;

  /**
   * element for scrolling to the top
   */
  @ViewChild('top') top: ElementRef;

  /**
   * construktor
   * @param backendService
   * @param router
   * @param cameraService
   * @param dialog
   * @param sanitizer
   * @param http
   * @param websockeService
   * @param snackBar
   * @param translate
   * @param route
   * @param requestService
   * @param embedService
   * @param portalService
   * @param elementService
   */
  constructor(private backendService: HeizcheckBackendService, private router: Router, private cameraService: CameraService,
              public dialog: MatDialog, private sanitizer: DomSanitizer, protected http: HttpClient, private websockeService: WebsocketService, public snackBar: MatSnackBar,
              private translate: TranslateService, private route: ActivatedRoute, private requestService: HeizcheckRequestService, private embedService: EmbedService,
              private portalService: PortalService, private elementService: ElementService, protected energyMapService: EnergyMapService) {
  }

  /**
   * @inheritDoc
   */
  ngAfterViewInit(): void {
    // scroll to the top
    this.elementService.scrollToElement(this.top.nativeElement);
  }

  /**
   * When the component is initialized
   */
  ngOnInit(): void {
    this.route.data.subscribe(data => {
      if(data.hasOwnProperty('mode')) {
        this.mode = data.mode;
      }
    });

    // getting the request object
    this.anfrage = this.requestService.getAnfrage();

    // are we embedded or not
    this.isEmbedded = this.embedService.isEmbedded();

    // get the redirect URl
    this.redirectUrl = __advisorRedirectUrl;

    // get the minimum of detected values for a success
    this.minDetectedValueCount = HeizcheckConstants.DETECTION_MIN_VALUECOUNT;

    for(let i=1; i<5; i++) {
      this.files.push({id: 'file-' + i, file: null});
    }

    // get the request ID and generate the URL for taking pictures
    this.backendService.getRequestId().subscribe((id) => {
      // create photo URL for taking pictures
      this.photoURL = document.location.protocol + '//' + document.location.host + '/' + this.portalService.currentPortalId + '/heizcheck/foto?' + HeizcheckRequestService.PARAM_NAME_REQUESTID + '=' + id;
      console.debug("fotoUrl", this.photoURL)

      // register on websocket server
      this.initWebsocket(id);

      // check one time if we have already some images
      this.updatePreviewimages();

      // check if we should start the analysis and do this if requested
      this.route.queryParams.subscribe(params => {
        if(params.hasOwnProperty('startAnalysis') && (params.startAnalysis * 1) === 1) {
          if(params.hasOwnProperty('msp')) {
            this.updateMsp(params.msp);
          }
          this.startAnalysis();
        }
      });
    });

    if(this.mode === 'foto' && !this.fotoNumber) {
      // get new number for the fotos from backend
      this.backendService.getRedirectString({'url': this.photoURL}).subscribe(redirectNumber => {
        this.fotoNumber = redirectNumber;
      }, error => {
        // and error occure, let's hope it's onyl a DB error and we'll try this one more time
        setTimeout(() => {
          this.backendService.getRedirectString({'url': this.photoURL}).subscribe(redirectNumber => {
            this.fotoNumber = redirectNumber;
          });
        }, 300)
      });
    }

    // init msp field, if not already there
    if(this.getMsp() === null) {
      this.updateMsp('');
    }

    // check if we have a saved result
    this.initDetectedValues();
  }

  /**
   * updates the msp;
   * @param msp
   */
  updateMsp(msp: string): void {
    this.anfrage.heizkostenanalyseInput.messdienstleister = msp;
    this.requestService.setAnfrage(this.anfrage);
  }

  /**
   * get the current msp from the users request
   */
  getMsp(): string {
    return this.anfrage.heizkostenanalyseInput?.messdienstleister?? null;
  }

  /**
   * initialize the websocket connection and handlie messages.
   * @param id
   */
  initWebsocket(id: string): void {
    this.websockeService.connect(id, HeizcheckConstants.WEBSOCKET_SENDER_DESKTOP);

    this.webserviceSubscription = this.websockeService.messages$.subscribe(message => {
      switch(message['message']) {
        case 'mobile_registered':
          // open info overlay
          this.showFotoPreviewDialog([]);
          this.updatePreviewimages();
          break;
        case HeizcheckConstants.WEBSOCKET_MESSAGE_CONNECTION_LOST:
          if(this.previewDialog) {
            // close preview dialog of the connection is lost
            this.closeFotoPreviewDialog();
          }
          break;
        case HeizcheckConstants.WEBSOCKET_MESSAGE_IMAGEUDPATE:
          this.showFotoPreviewDialog([]);
          this.updatePreviewimages();
          break;
        case HeizcheckConstants.WEBSOCKET_MESSAGE_STARTCAMERA:
        case HeizcheckConstants.WEBSOCKET_MESSAGE_STOPCAMERA:
          if(this.previewDialog && this.previewDialog.componentInstance) {
            // update the images in the dialog
            this.previewDialog.componentInstance.setLoading(message['message'] === HeizcheckConstants.WEBSOCKET_MESSAGE_STARTCAMERA);
          }
          break;
        case HeizcheckConstants.WEBSOCKET_MESSAGE_UPLOADFINISHED:
          this.previewDialog.close();
          this.startAnalysis();
          break;
        case HeizcheckConstants.WEBSOCKET_MESSAGE_KI_SUCCESS:
        case HeizcheckConstants.WEBSOCKET_MESSAGE_KI_ERROR:
          // KI analyses is finished, get the result.
          this.getAnalysisResult();
          break;
        case HeizcheckConstants.WEBSOCKET_MESSAGE_MSP_SELECTED:
          this.updateMsp(message['data']['msp']);
          break;
      }

    });
  }

  /**
   * get the preview images from mobile device.
   */
  updatePreviewimages(): void {
    this.backendService.getRequestId().subscribe((id) => {
      this.http.get('/smh/foto/status/' + id).subscribe(
        result => {
          // check if connected, if yes => show overlay and images.
          if(result['connected'] === true) {
            if(this.previewDialog && this.previewDialog.componentInstance) {
              // update the images in the dialog
              this.previewDialog.componentInstance.data = {images: result['images'], loading: false};
            }
          }
        },
        error => {
          console.error("Error while checking status with the backend.", error);
        }
      );
    });
  }

  /**
   * Opens a preview dialog
   * @param images
   */
  showFotoPreviewDialog(images: any): void {
    if(this.previewDialog === null) {
      const dialogRef = this.previewDialog = this.dialog.open(FotoPreviewComponent, {
        data: {
          images: images,
          loading: false,
        }
      });

      // reset the local dialog to avoid errors when the dialog can not be opened again.
      dialogRef.afterClosed().subscribe(() => this.previewDialog = null);
    }
  }

  /**
   * close the dialogue
   */
  closeFotoPreviewDialog(): void {
    if(this.previewDialog) {
      this.previewDialog.close();
      this.previewDialog = null;
    }
  }

  /**
   * Eventhandler if a file is de/selected
   * @param fileData
   */
  onFileSelected(fileData: {id: string, file: HTMLInputElement}): void {
    const index = this.files.map(e => e.id).indexOf(fileData.id);

    if(this.files[index]) {
      this.files[index].file = fileData.file;
    }
  }

  /**
   * Decide to show an upload field as disabled or not.
   * @param fileId
   */
  isFileDisabled(fileId: string) {
    const index = this.files.map(e => e.id).indexOf(fileId);

    // the first item is always NOT disabled
    if(index === 0) {
      return false;
    }

    // check if the one before as a select
    return this.files[index - 1].file === null;
  }

  /**
   * Checks if we have at least one file that should be analysed.
   */
  fileUploadPossible(): number {
    if(this.getMsp() === '') {
      // no msp set, form can not be uploaded
      return -1;
    }

    if(!this.files.find(element => element.file !== null)) {
      return -2;
    }

    if(this.terms === false) {
      return -3;
    }

    return 0;
  }

  /**
   * Returns the label text for the submit button
   */
  getButtonText(): string {
    switch(this.fileUploadPossible()) {
      case -1:
      case -2:
        return 'heizcheck.upload.error';
      case -3:
        return 'heizcheck.upload.terms';
      default:
        return 'heizcheck.upload.submit'
    }
  }

  /**
   * Uploads the files to the server.
   */
  uploadData(): void {

    if(this.fileUploadPossible() !== 0) {
      // do nothing, there is nothing to uploads
      this.error = '.forminvalid'
      return;
    }

    // reset error
    this.error = null;

    this.backendService.getRequestId().subscribe((id) => {
      const data = new FormData();
      if(this.files.length > 0) {
        for(let i=0; i<this.files.length; i++) {
          if(this.files[i].file) {
            data.append('file[]', this.files[i].file.files[0]);
          }
        }
      }
      this.uploadPercentage = null;

      this.http.post('/smh/save/files/' + id, data, {reportProgress: true, observe: 'events'}).subscribe(
        response => {
          switch(response.type) {
            case HttpEventType.UploadProgress:
              // we have a upload progress information, update the counter
              this.uploadPercentage = Math.round(100 * response.loaded / response.total);
              break;
            case HttpEventType.Response:
            default:
              if(response["status"] === 200) {
                // we have a success!
                const result = response["body"]? response["body"] : null;
                if(result && result["saved"] === true) {
                  this.uploadPercentage = 100;
                  // start analysis
                  this.startAnalysis();
                }
              }
              break;
          }
        },
        error => {
          // Show error message
          this.translate.get(['heizcheck.foto.snackbar.error.uploaderror', 'output.erfassen.snackbar.ok']).subscribe(texts => {
            this.snackBar.open(texts['heizcheck.foto.snackbar.error.uploaderror'], texts['output.erfassen.snackbar.ok'], {
              panelClass: 'error',
              duration: HeizcheckConstants.SNACKBAR_DURATION_DEFAULT,
              verticalPosition: HeizcheckConstants.SNACKBAR_POSITION_VERTICAL
            });
          });
          this.uploadPercentage = null;
        }
      );
    });
  }

  /**
   * Starts the analysation of the data. Send the start command to the backend and waits for the result.
   */
  startAnalysis(): void {

    // show dialog that we start now
    const position = this.embedService.isEmbedded()? {top: ((Math.min(0, this.embedService.currentOffset) * -1) + 100) + "px"} : {};

    this.infoDialog = this.dialog.open(InfoOverlayComponent,{
      position: position,
      disableClose: true,
      panelClass: 'center',
      data: {
        title: 'heizcheck.analysis.overlay.title',
        body: 'heizcheck.analysis.overlay.body0',
        animation: true,
        countdownSeconds: 183
      }
    });

    // switch body texts on the overlay to entertain the user
    let index = 1;
    this.interval = setInterval(() => {
      if(!this.infoDialog || ! this.infoDialog.componentInstance) {
        // an error occured in the meantime, stop the interval
        clearInterval(this.interval);
        return;
      }
      this.infoDialog.componentInstance.setNewBodytext('heizcheck.analysis.overlay.body' + index);
      if(index === 5) {
        index = 0;
      }
      else {
        index++;
      }
    }, 10000);

    // start analysis via websocket server.
    this.backendService.getRequestId().subscribe((id) => {
      this.websockeService.sendMessage(id, HeizcheckConstants.WEBSOCKET_SENDER_DESKTOP, HeizcheckConstants.WEBSOCKET_MESSAGE_KI_START, {msp: this.getMsp()});
    });
  }

  /**
   * Receives the result from the backend of a (finished) KI analysis.
   */
  getAnalysisResult(): void {
    this.backendService.getRequestId().subscribe((id) => {
      this.http.get('/smh/save/analyse/' + id + '/' + this.getMsp()).subscribe(result => {
        clearInterval(this.interval);

        // clear the result from not useful values and unknown fields
        this.requestService.clearResult(result);

        // Save the result locally
        this.anfrage.detectedData = result;
        this.requestService.setAnfrage(this.anfrage);
        this.initDetectedValues();

        // close dialog and redirect to next step
        if(this.infoDialog && this.infoDialog.componentInstance) {
          this.infoDialog.close();
        }

        // remeber current status
        this.oldMode = this.mode;

        // show result
        this.mode = 'result';

        // scroll up
        setTimeout(() => this.elementService.scrollToElement(this.top.nativeElement), 100);

      }, error => {
        // error while talking to the backend. Show error message
        console.error("Something went wrog when starting the analysis", error);
        this.infoDialog.close();
        this.uploadPercentage = null;
        this.translate.get(['heizcheck.foto.snackbar.error.analysiserror', 'output.erfassen.snackbar.ok']).subscribe(texts => {
          this.snackBar.open(texts['heizcheck.foto.snackbar.error.analysiserror'], texts['output.erfassen.snackbar.ok'], {
            panelClass: 'error',
            duration: HeizcheckConstants.SNACKBAR_DURATION_DEFAULT,
            verticalPosition: HeizcheckConstants.SNACKBAR_POSITION_VERTICAL
          });
        });
      });
    });
  }

  /**
   * when the component is destroyed, close websocket connection.
   */
  ngOnDestroy(): void {
    this.closeFotoPreviewDialog();
    this.websockeService.closeConnection();
    this.webserviceSubscription.unsubscribe();
  }

  /**
   * Count the number of detected values in the result.
   */
  initDetectedValues(): void {
    this.detectedValueCount = 0;

    if(this.anfrage.detectedData?.fields) {
      // calculate the number o f keys that we found, based on the available fieldIds
      const keys = [].concat(...Object.keys(this.anfrage.detectedData?.fields).map(key => Object.keys(this.anfrage.detectedData?.fields[key])));
      if(keys.indexOf("abrechnungszeitraum") > 0) {
        // special case, dates are splitted into two fields
        keys.push('abrechnung_von');
        keys.push('abrechnung_bis');
      }
      const formConfig = new HeizkostenabrechnungForm(this.energyMapService);
      const formFieldIds = [].concat(...formConfig.getFields().map(field => field.getIds()));
      this.detectedValueCount = keys.filter(key => formFieldIds.indexOf(key) > 0).length;
    }
  }

  /**
   * TODO: implement this
   */
  backFromtResult(): void {
    console.log("TODO, implement this");
  }

}
